(function menuWrapAndDropdownState() {
  let frame;
  const dropdownOpenClass = 'menu__item--dropdown-open';

  function getMenuItems(menu) {
    return Array.prototype.filter.call(menu.children, function (child) {
      return child.classList && child.classList.contains('menu__item');
    });
  }

  function clearMenuRowState(items) {
    items.forEach(function (item) {
      item.classList.remove('menu__item--row-top', 'menu__item--row-bottom');
      item.style.removeProperty('--menu-dropdown-offset-y');
    });
  }

  function getMenuRows(items) {
    const rowTolerance = 8;

    return items
      .reduce(function (rows, item) {
        const itemTop = item.getBoundingClientRect().top;
        const row = rows.find(function (candidate) {
          return Math.abs(candidate.top - itemTop) <= rowTolerance;
        });

        if (row) {
          row.items.push(item);
          row.top = Math.min(row.top, itemTop);
        } else {
          rows.push({ top: itemTop, items: [item] });
        }

        return rows;
      }, [])
      .sort(function (rowA, rowB) {
        return rowA.top - rowB.top;
      });
  }

  function setWrappedDropdownOffsets(header, items) {
    const section = header.closest('[data-section-type="header"]');
    const headerShell = section ? section.querySelector('.theme__header') : null;
    const targetBottom = (headerShell || header).getBoundingClientRect().bottom;
    const rows = getMenuRows(items);

    if (rows.length < 2) return;

    const rowTolerance = 8;
    const firstTop = rows[0].top;
    const lastTop = rows[rows.length - 1].top;

    items.forEach(function (item) {
      const itemTop = item.getBoundingClientRect().top;
      const isTopRow = Math.abs(itemTop - firstTop) <= rowTolerance;
      const isBottomRow = Math.abs(itemTop - lastTop) <= rowTolerance;

      item.classList.toggle('menu__item--row-top', isTopRow);
      item.classList.toggle('menu__item--row-bottom', isBottomRow);

      if (item.classList.contains('parent')) {
        const offset = Math.max(0, Math.round(targetBottom - item.getBoundingClientRect().bottom));
        item.style.setProperty('--menu-dropdown-offset-y', offset + 'px');
      }
    });
  }

  function updateMenuWrapState() {
    if (frame) {
      window.cancelAnimationFrame(frame);
    }

    frame = window.requestAnimationFrame(function () {
      document.querySelectorAll('[data-section-type="header"] .header__desktop').forEach(function (header) {
        const menu = header.querySelector('.header__menu');
        if (!menu || header.offsetParent === null) {
          header.classList.remove('is-menu-wrapped');
          clearMenuRowState(getMenuItems(menu || header));
          return;
        }

        header.classList.remove('is-menu-wrapped');

        const items = getMenuItems(menu);
        if (!items.length) return;

        clearMenuRowState(items);

        const isWrapped = getMenuRows(items).length > 1;

        header.classList.toggle('is-menu-wrapped', isWrapped);

        if (isWrapped) {
          setWrappedDropdownOffsets(header, items);
        }
      });

      document.dispatchEvent(new CustomEvent('theme:resize'));
    });
  }

  function syncDropdownOpenState(menu) {
    if (!menu) return;

    getMenuItems(menu).forEach(function (item) {
      if (!item.classList.contains('parent') && !item.classList.contains('grandparent')) return;

      const dropdown = item.querySelector(':scope > .header__dropdown');
      const isOpen =
        item.classList.contains('is-visible') ||
        item.getAttribute('aria-expanded') === 'true' ||
        item.matches(':hover') ||
        item.contains(document.activeElement) ||
        Boolean(dropdown && dropdown.classList.contains('is-visible'));

      item.classList.toggle(dropdownOpenClass, isOpen);
    });
  }

  function connectDropdownOpenState() {
    document.querySelectorAll('[data-header-style="logo_beside"] .header__menu').forEach(function (menu) {
      syncDropdownOpenState(menu);

      if (menu.getAttribute('data-dropdown-open-state-bound') === 'true') return;

      menu.setAttribute('data-dropdown-open-state-bound', 'true');

      ['mouseenter', 'mouseleave', 'mouseover', 'focusin', 'focusout'].forEach(function (eventName) {
        menu.addEventListener(
          eventName,
          function () {
            window.requestAnimationFrame(function () {
              syncDropdownOpenState(menu);
            });
          },
          true
        );
      });

      if (!window.MutationObserver) return;

      const observer = new MutationObserver(function () {
        window.requestAnimationFrame(function () {
          syncDropdownOpenState(menu);
        });
      });

      observer.observe(menu, {
        subtree: true,
        attributes: true,
        attributeFilter: ['class', 'aria-expanded'],
      });
    });
  }

  document.addEventListener('DOMContentLoaded', updateMenuWrapState);
  document.addEventListener('DOMContentLoaded', connectDropdownOpenState);
  document.addEventListener('shopify:section:load', function () {
    updateMenuWrapState();
    connectDropdownOpenState();
  });
  document.addEventListener('theme:resize:width', function () {
    updateMenuWrapState();
    connectDropdownOpenState();
  });
  window.addEventListener('resize', updateMenuWrapState);

  if (document.fonts && document.fonts.ready) {
    document.fonts.ready.then(function () {
      updateMenuWrapState();
      connectDropdownOpenState();
    });
  }

  updateMenuWrapState();
  connectDropdownOpenState();
})();

(function searchToggle() {
  function getToggleButton(panel) {
    return document.querySelector('[data-search-toggle][aria-controls="' + panel.id + '"]');
  }

  function closeSearchPanel(panel) {
    if (!panel || !panel.classList.contains('is-visible')) return;

    panel.classList.remove('is-visible');

    if (panel.contains(document.activeElement)) {
      document.activeElement.blur();
    }

    const button = getToggleButton(panel);
    if (button) button.setAttribute('aria-expanded', 'false');

    const predictiveSearch = panel.querySelector('predictive-search');
    if (predictiveSearch) {
      if (typeof predictiveSearch.close === 'function') {
        predictiveSearch.close();
      } else {
        predictiveSearch.removeAttribute('open');
      }
    }

  }

  function openSearchPanel(panel) {
    if (!panel || panel.classList.contains('is-visible')) return;

    document.querySelectorAll('[data-search-toggle-panel].is-visible').forEach(function (openPanel) {
      if (openPanel !== panel) closeSearchPanel(openPanel);
    });

    panel.classList.add('is-visible');

    const button = getToggleButton(panel);
    if (button) button.setAttribute('aria-expanded', 'true');

    window.requestAnimationFrame(function () {
      const input = panel.querySelector('.header__search-bar__input');
      if (input) input.focus({ preventScroll: true });
    });
  }

  document.addEventListener('click', function (event) {
    const button = event.target.closest('[data-search-toggle]');

    if (button) {
      const panel = document.getElementById(button.getAttribute('aria-controls'));
      if (!panel) return;

      if (panel.classList.contains('is-visible')) {
        closeSearchPanel(panel);
      } else {
        openSearchPanel(panel);
      }
      return;
    }

    const innerClick = event.target.closest('.header__desktop__search-panel__inner');
    if (innerClick && event.target === innerClick) {
      const panel = innerClick.closest('[data-search-toggle-panel]');
      if (panel) closeSearchPanel(panel);
      return;
    }

    document.querySelectorAll('[data-search-toggle-panel].is-visible').forEach(function (panel) {
      if (!panel.contains(event.target)) closeSearchPanel(panel);
    });
  });

  document.addEventListener('keyup', function (event) {
    if (event.key !== 'Escape' && event.code !== 'Escape') return;

    document.querySelectorAll('[data-search-toggle-panel].is-visible').forEach(closeSearchPanel);
  });
})();

(function cartBadgeSync() {
  const cartCountSelector = '.header__cart__status[data-cart-count]';
  let fetchTimer;
  let observer;

  function parseCount(value) {
    const count = parseInt(String(value || '').replace(/[^0-9]/g, ''), 10);
    return isNaN(count) ? 0 : count;
  }

  function setStatusCount(status, count) {
    const normalizedCount = parseCount(count);
    const normalizedString = String(normalizedCount);
    const limit = parseCount(status.getAttribute('data-limit'));
    const displayCount = limit && normalizedCount >= limit ? '9+' : normalizedString;

    if (status.getAttribute('data-cart-count') !== normalizedString) {
      status.setAttribute('data-cart-count', normalizedString);
    }

    if (status.textContent.trim() !== displayCount) {
      status.textContent = displayCount;
    }

    status.classList.toggle('has-items', normalizedCount > 0);
  }

  function setAllStatusCounts(count) {
    document.querySelectorAll(cartCountSelector).forEach(function (status) {
      setStatusCount(status, count);
    });
  }

  function syncVisibleStatusCounts() {
    document.querySelectorAll(cartCountSelector).forEach(function (status) {
      setStatusCount(status, status.getAttribute('data-cart-count') || status.textContent);
    });
  }

  function cartJsonUrl() {
    const root = window.theme && window.theme.routes && window.theme.routes.root ? window.theme.routes.root : '/';
    return root.replace(/\/?$/, '/') + 'cart.js';
  }

  function fetchCartCount(delay) {
    clearTimeout(fetchTimer);
    fetchTimer = setTimeout(function () {
      fetch(cartJsonUrl(), { credentials: 'same-origin' })
        .then(function (response) {
          return response.ok ? response.json() : null;
        })
        .then(function (cart) {
          if (cart && typeof cart.item_count !== 'undefined') {
            setAllStatusCounts(cart.item_count);
          }
        })
        .catch(function () {});
    }, delay || 150);
  }

  function handleCartChange(event) {
    if (event.detail && typeof event.detail.cartCount !== 'undefined') {
      setAllStatusCounts(event.detail.cartCount);
      return;
    }

    fetchCartCount();
  }

  function observeStatusCounts() {
    if (!window.MutationObserver) {
      syncVisibleStatusCounts();
      return;
    }

    if (observer) {
      observer.disconnect();
    }

    observer = new MutationObserver(function (mutations) {
      mutations.forEach(function (mutation) {
        const target = mutation.target.nodeType === 1 ? mutation.target : mutation.target.parentElement;
        const status = target && target.closest ? target.closest(cartCountSelector) : null;

        if (status) {
          setStatusCount(status, status.getAttribute('data-cart-count') || status.textContent);
        }
      });
    });

    document.querySelectorAll(cartCountSelector).forEach(function (status) {
      observer.observe(status, {
        attributes: true,
        attributeFilter: ['data-cart-count'],
        childList: true,
        characterData: true,
        subtree: true,
      });

      setStatusCount(status, status.getAttribute('data-cart-count') || status.textContent);
    });
  }

  document.addEventListener('DOMContentLoaded', observeStatusCounts);
  document.addEventListener('shopify:section:load', observeStatusCounts);
  document.addEventListener('theme:cart:change', handleCartChange);
  document.addEventListener('theme:product:add', function () {
    fetchCartCount();
  });
  document.addEventListener('theme:cart:update', function () {
    fetchCartCount(700);
  });

  [
    'rebuy:cart.change',
    'rebuy:smartcart.show',
    'rebuy:smartcart.line-item-increase',
    'rebuy:smartcart.line-item-decrease',
    'rebuy:smartcart.line-item-removed',
    'rebuy:smartcart.item-switch-to-subscription',
    'rebuy:smartcart.item-switch-to-one-time',
  ].forEach(function (eventName) {
    document.addEventListener(eventName, function () {
      fetchCartCount(200);
    });
  });

  observeStatusCounts();
})();

(function mobileSearchBarScrollHide() {
  const searchBar = document.querySelector('[data-mobile-search-bar]');
  if (!searchBar) return;

  const header = searchBar.closest('[data-header-height]');
  const headerWrapper = searchBar.closest('[data-header-wrapper]');
  const headerMobile = header ? header.querySelector('.header__mobile') : null;
  const predictiveSearch = searchBar.querySelector('predictive-search');
  const predictiveSearchResults = predictiveSearch
    ? predictiveSearch.querySelector('[data-predictive-search-results]')
    : null;
  const threshold = 50;
  const topScrollRatio = 0.05;
  const directionThreshold = 12;
  const transitionDuration = 450;
  let scrollFrame;
  let transitionTimer;
  let isTransitioning = false;
  let isSearchBarVisible = searchBar.classList.contains('is-visible');
  let scrollDirection;
  let directionStartPosition = window.scrollY;
  let expandedHeaderHeight = header ? header.offsetHeight : 0;
  let collapsedHeaderHeight = header ? Math.max(0, expandedHeaderHeight - searchBar.offsetHeight) : 0;
  let predictiveSearchResizeFrame;

  function resizeMobilePredictiveSearchResults() {
    if (!predictiveSearchResults) return;

    window.cancelAnimationFrame(predictiveSearchResizeFrame);

    if (window.innerWidth > 767) {
      predictiveSearchResults.style.removeProperty('height');
      predictiveSearchResults.style.removeProperty('max-height');
      return;
    }

    if (!predictiveSearch.hasAttribute('open') && !predictiveSearch.hasAttribute('loading')) return;

    predictiveSearchResizeFrame = window.requestAnimationFrame(function () {
      const viewport = window.visualViewport;
      const viewportBottom = viewport ? viewport.offsetTop + viewport.height : window.innerHeight;
      const resultsTop = predictiveSearchResults.getBoundingClientRect().top;
      const availableHeight = Math.max(180, Math.floor(viewportBottom - resultsTop - 16));

      predictiveSearchResults.style.removeProperty('height');
      predictiveSearchResults.style.setProperty('max-height', `${availableHeight}px`, 'important');
    });
  }

  if (predictiveSearchResults) {
    const predictiveSearchObserver = new MutationObserver(resizeMobilePredictiveSearchResults);
    predictiveSearchObserver.observe(predictiveSearch, {
      attributes: true,
      attributeFilter: ['open', 'loading'],
    });

    predictiveSearchResults.addEventListener('wheel', function (event) {
      event.stopPropagation();
    }, { passive: true });

    predictiveSearchResults.addEventListener('touchmove', function (event) {
      event.stopPropagation();
    }, { passive: true });

    window.visualViewport?.addEventListener('resize', resizeMobilePredictiveSearchResults);
  }

  function rememberHeaderHeights() {
    if (!header || !isSearchBarVisible || isTransitioning) return;

    expandedHeaderHeight = header.getBoundingClientRect().height;
    const searchBarHeight = searchBar.getBoundingClientRect().height;
    const rowGap =
      headerMobile && window.innerWidth >= 768 && window.innerWidth <= 1023
        ? parseFloat(window.getComputedStyle(headerMobile).rowGap) || 0
        : 0;
    collapsedHeaderHeight = Math.max(0, expandedHeaderHeight - searchBarHeight - rowGap);

    document.documentElement.style.setProperty(
      '--collection-sticky-collapsed-header-height',
      `${collapsedHeaderHeight}px`
    );
    document.documentElement.style.setProperty('--mobile-search-bar-height', `${searchBarHeight}px`);
  }

  rememberHeaderHeights();

  function getTopProtectionThreshold() {
    const scrollableHeight = Math.max(0, document.documentElement.scrollHeight - window.innerHeight);
    return Math.max(threshold, scrollableHeight * topScrollRatio);
  }

  function finishTransition() {
    clearTimeout(transitionTimer);
    isTransitioning = false;

    const headerIsStuck = headerWrapper && headerWrapper.classList.contains('js__header__stuck');
    if (!isSearchBarVisible && (Math.max(0, window.scrollY) <= getTopProtectionThreshold() || !headerIsStuck)) {
      setSearchBarVisible(true);
    }
  }

  function closePredictiveSearch() {
    if (!predictiveSearch) return;

    if (typeof predictiveSearch.close === 'function') {
      predictiveSearch.close();
      return;
    }

    predictiveSearch.removeAttribute('open');
    predictiveSearch.querySelector('[data-predictive-search-input]')?.setAttribute('aria-expanded', 'false');
    predictiveSearch.querySelector('[data-predictive-search-results]')?.removeAttribute('style');
  }

  document.addEventListener('pointerdown', function (event) {
    document.querySelectorAll('.header__search-bar predictive-search[open]').forEach(function (instance) {
      const searchContainer = instance.closest('.header__search-bar');
      if (searchContainer && searchContainer.contains(event.target)) return;

      if (typeof instance.close === 'function') {
        instance.close();
      } else {
        instance.removeAttribute('open');
        instance.querySelector('[data-predictive-search-input]')?.setAttribute('aria-expanded', 'false');
        instance.querySelector('[data-predictive-search-results]')?.removeAttribute('style');
      }
    });
  });

  function setSearchBarVisible(visible) {
    if (visible === isSearchBarVisible) return;

    isSearchBarVisible = visible;
    isTransitioning = true;
    searchBar.classList.toggle('is-visible', visible);

    if (!visible) {
      closePredictiveSearch();
    }

    clearTimeout(transitionTimer);
    transitionTimer = setTimeout(finishTransition, transitionDuration);
  }

  document.addEventListener('theme:scroll', function (event) {
    const { up, down, position } = event.detail;
    const normalizedPosition = Math.max(0, position);
    const nextDirection = down ? 'down' : up ? 'up' : null;

    if (nextDirection && nextDirection !== scrollDirection) {
      scrollDirection = nextDirection;
      directionStartPosition = position;
    }

    if (window.innerWidth >= 1024) return;

    const predictiveSearchIsOpen =
      predictiveSearch &&
      (predictiveSearch.hasAttribute('open') || predictiveSearch.hasAttribute('loading'));

    if (predictiveSearchIsOpen) {
      window.cancelAnimationFrame(scrollFrame);
      setSearchBarVisible(true);
      return;
    }

    const topProtectionThreshold = getTopProtectionThreshold();
    if (normalizedPosition <= topProtectionThreshold) {
      window.cancelAnimationFrame(scrollFrame);
      setSearchBarVisible(true);
      return;
    }

    if (isTransitioning) return;

    window.cancelAnimationFrame(scrollFrame);
    scrollFrame = window.requestAnimationFrame(function () {
      const headerIsStuck = headerWrapper && headerWrapper.classList.contains('js__header__stuck');
      const hideThreshold = Math.max(
        topProtectionThreshold,
        threshold + Math.max(0, expandedHeaderHeight - collapsedHeaderHeight)
      );
      const directionDistance = Math.abs(position - directionStartPosition);

      if (down && directionDistance >= directionThreshold && normalizedPosition > hideThreshold && headerIsStuck) {
        setSearchBarVisible(false);
      } else if (up && directionDistance >= directionThreshold) {
        setSearchBarVisible(true);
      }
    });
  });

  document.addEventListener('theme:resize:width', rememberHeaderHeights);
  window.addEventListener('load', rememberHeaderHeights, { once: true });
})();
